import { useState, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import useWindowResize from "~/hooks/useWindowResize";
import Logo from "~/assets/logo-trans.png";
import LogoSmall from "~/assets/logo-icon.png";
import { useTabStore } from "~/stores";
import { SEARCH_TABS } from "~/types/search.types";
import { SearchActions } from "~/types/actions.enum";

const ExploreLogo: React.FunctionComponent = () => {
    const [logo, setLogo] = useState(Logo);
    const { windowSize } = useWindowResize();
    const navigate = useNavigate();
    const dispatchTab = useTabStore(state => state.dispatch);

    const goToHomepage = (e: React.MouseEvent) => {
        e.preventDefault();

        dispatchTab({
            type: SearchActions.SET_ACTIVETAB_BY_KEY,
            payload: SEARCH_TABS.IMAGES
        });

        navigate("/search");
    };

    useLayoutEffect(() => {
        if (windowSize.width < 1024) {
            setLogo(LogoSmall);
        } else {
            setLogo(Logo);
        }
    }, [windowSize]);

    return (
        <button className="lg:mr-8" onClick={goToHomepage}>
            <img className="h-[50px]" src={logo} alt="Explore Logo" />
        </button>
    );
};

export default ExploreLogo;
